let swiper;
window.globals = {};
const body = document.body;
const lightboxImages = document.querySelectorAll("[lightbox-toggle] img");
const initLightbox = lightboxImages.length > 0;

const createLightboxSkeleton = () => {
  // Create skeleton for lightbox
  const lightbox = document.createElement("div");
  lightbox.classList.add("lalo-lightbox");
  body.appendChild(lightbox);

  const lightboxContainer = document.createElement("div");
  lightboxContainer.classList.add("lalo-lightbox__container");
  lightbox.appendChild(lightboxContainer);

  const lightboxClose = document.createElement("div");
  lightboxClose.classList.add("lalo-lightbox__close");
  lightboxClose.setAttribute("tabindex", "0");
  lightboxClose.innerHTML = '<i class="icon-close"></i>';
  lightboxContainer.appendChild(lightboxClose);

  const swiperContainer = document.createElement("div");
  swiperContainer.classList.add("swiper");
  lightboxContainer.appendChild(swiperContainer);

  const swiperWrapper = document.createElement("div");
  swiperWrapper.classList.add("swiper-wrapper");
  swiperContainer.appendChild(swiperWrapper);

  const swiperBtnNext = document.createElement("div");
  swiperBtnNext.classList.add("swiper-button-next");
  swiperContainer.appendChild(swiperBtnNext);

  const swiperBtnPrev = document.createElement("div");
  swiperBtnPrev.classList.add("swiper-button-prev");
  swiperContainer.appendChild(swiperBtnPrev);

  // Set variables to reference the lightbox
  globals.lightboxRef = document.querySelector(".lalo-lightbox");
  globals.swiperWrapperRef = document.querySelector(
    ".lalo-lightbox .swiper-wrapper"
  );
};

if (initLightbox) {
  createLightboxSkeleton();

  lightboxImages.forEach(function (el, index) {
    el.addEventListener("click", imageClick, false);

    function imageClick() {
      // Clear swiper before trying to add to it
      globals.swiperWrapperRef.innerHTML = "";

      lightboxImages.forEach(function (img) {
        const image = img.cloneNode(true);
        const slide = document.createElement("div");
        const imageContainer = document.createElement("div");
        slide.classList.add("swiper-slide");

        imageContainer.classList.add("lalo-lightbox__image");
        imageContainer.appendChild(image);
        slide.appendChild(imageContainer);

        globals.swiperWrapperRef.appendChild(slide);
      });

      // Init Swiper
      swiper = new Swiper(".lalo-lightbox .swiper", {
        initialSlide: index,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: ".lalo-lightbox .swiper-button-next",
          prevEl: ".lalo-lightbox .swiper-button-prev",
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
      });

      globals.lightboxRef.classList.add("open");
      body.classList.add("is-drawer-opened");
    }
  });

  let destroySwiper = (swiper, timeout) => {
    setTimeout(() => {
      swiper.destroy();
    }, timeout);
  };

  // Close lightbox on click
  document.addEventListener(
    "click",
    ({ target }) => {
      if (target.matches(".lalo-lightbox__close *")) {
        destroySwiper(swiper, 250);
        globals.lightboxRef.classList.remove("open");
        body.classList.remove("is-drawer-opened");
      }
    },
    false
  );

  document.addEventListener("click", function (evt) {
    let laloLightbox = document.querySelector(".lalo-lightbox");
    let laloLightboxGrid = document.querySelector(
      ".ugc-section[lightbox-toggle]"
    );
    targetEl = evt.target;

    if (document.querySelector(".lalo-lightbox.open")) {
      do {
        if (targetEl == laloLightbox || targetEl == laloLightboxGrid) {
          return;
        }
        targetEl = targetEl.parentNode;
      } while (targetEl);
      destroySwiper(swiper, 250);
      globals.lightboxRef.classList.remove("open");
      body.classList.remove("is-drawer-opened");
    }
  });

  // Close lightbox on escape key press
  document.addEventListener("keydown", ({ key }) => {
    if (key === "Escape" && swiper) {
      destroySwiper(swiper, 250);
      globals.lightboxRef.classList.remove("open");
      body.classList.remove("is-drawer-opened");
    }
  });
}
